import { IonIcon, isPlatform } from '@ionic/react';
import { checkmark } from 'ionicons/icons';
import React, { ReactElement, ReactNode, useRef } from 'react';
import { useCancellableLongPress } from '../../../../../../util/hooks';

interface FlowItemIconProps {
  className?: string;
  onLongPress?: (e: Event) => void;
  onClick?: (
    e: React.MouseEvent<HTMLDivElement | HTMLIonButtonElement, MouseEvent>
  ) => void;
  icon: ReactNode;
  isItemSelected?: boolean;
}

const FlowItemIcon = (props: FlowItemIconProps): ReactElement => {
  const { className, onLongPress, onClick, icon, isItemSelected } = props;

  const longPressInvoked = useRef<boolean>(false);
  const isLongPressEnabled = onLongPress !== undefined;

  const handleIconLongPress = useCancellableLongPress(
    (e) => {
      if (isLongPressEnabled && typeof onLongPress === 'function') {
        longPressInvoked.current = true;
        onLongPress(e);
        if (isPlatform('capacitor') || isPlatform('mobileweb')) {
          longPressInvoked.current = false;
        }
      }
    },
    { isPreventDefault: false, yThreshold: 10, xThreshold: 10 }
  );

  const classList = ['machine-flow-item-icon'];
  if (className) {
    classList.push(className);
  }

  return (
    <div
      className={classList.join(' ')}
      {...handleIconLongPress}
      onClick={onClick}
    >
      {isItemSelected ? <IonIcon icon={checkmark} /> : icon}
    </div>
  );
};

export { FlowItemIcon };
